import { useT } from '@/app/i18n/client';
import type { IAccommodationOptionType } from '@/entities/accommodation/types';

interface IProps {
  selectedOption: IAccommodationOptionType | null;
}
export default function AccommodationAdditionalGuestOptionWarning({ selectedOption }: IProps) {
  const { t } = useT('product');

  if (!selectedOption || selectedOption.type !== 'PER_PERSON') return null;

  return (
    <div className='my-4 rounded-2xl border-2 border-[#FEF3C7] bg-[#FFFBEB] p-4 text-sm text-[#2E2E2E]'>
      🌟 {t('additionalGuestOptionWarning')}
    </div>
  );
}
